import React from 'react';

import ExternalJobBoardsStatsLoader from './ExternalJobBoardsStatsLoader';
import { useJobProspectsStatsState, useJobProspectsStatsActions } from './JobProspectsStatsContext';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';
import { scheduleFindExternalJobBoards, scheduleExternalJobBoardWebpageCaching, scheduleFailedExternalJobBoardWebpageCaching, scheduleExternalJobBoardJobSync } from './restApi';
import styles from './ExternalJobBoardsStats.module.scss';

const ExternalJobBoardsStats = () => {
  const state = useJobProspectsStatsState();
  const { onResponse, onError } = useJobProspectsStatsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleScheduleFindJobBoards = () => {
    scheduleFindExternalJobBoards({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  const handleScheduleWebpageCaching = () => {
    scheduleExternalJobBoardWebpageCaching({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  const handleScheduleFailedWebpageCaching = () => {
    scheduleFailedExternalJobBoardWebpageCaching({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  const handleScheduleJobSync = () => {
    scheduleExternalJobBoardJobSync({
      onResponse,
      onError,
      body: {
        authenticity_token: authenticityToken,
      },
    });
  };

  return (
    <>
      <ExternalJobBoardsStatsLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text="External Job Boards Statistics" />
          <div style={{ marginBottom: '1rem' }}>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => window.location.href = '/job_prospects_stats'}
            >
              ← Back to Stats Overview
            </Button>
          </div>

          {state?.loading && <p>Loading...</p>}

          {!state?.loading && (
            <>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '1rem' }}>
                <p><strong>Total External Job Boards:</strong> {state?.total}</p>
                <hr />
                <p><strong>Pending:</strong> {state?.pending}</p>
                <p><strong>Webpage Cached:</strong> {state?.webpage_cached}</p>
                <p><strong>Webpage Cache Attempt Failed:</strong> {state?.webpage_cache_attempt_failed}</p>
                <p><strong>Verified:</strong> {state?.verified}</p>
                <p><strong>Rejected:</strong> {state?.rejected}</p>
                <p><strong>Auto-Rejected:</strong> {state?.auto_rejected}</p>
                <p><strong>Requires Reverification:</strong> {state?.requires_reverification}</p>
                <p><strong>Archived:</strong> {state?.archived}</p>
              </div>

              <ActionRow>
                <Button onClick={handleScheduleFindJobBoards}>
                  Find MA Group External Job Boards
                </Button>
                <Button onClick={handleScheduleWebpageCaching}>
                  Cache All Pending Job Board Webpages
                </Button>
                <Button onClick={handleScheduleFailedWebpageCaching}>
                  Retry Failed Job Board Webpages
                </Button>
                <Button onClick={handleScheduleJobSync}>
                  Sync All Active Job Boards
                </Button>
              </ActionRow>
            </>
          )}
        </Stack>
      </div>
    </>
  );
};

export default ExternalJobBoardsStats;
